const Loader = ({ centerLoader }) => {
  return (
    <div class={centerLoader}>
      <div
        class="spinner-border"
        style={{ width: "3rem", height: "3rem" }}
        role="status"
      >
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  );
};

export default Loader;
